<div class="row" *ngFor="let petDetail of selectedPatient.petsDetail">
  <div class="col-md-5">

    <table border="2" bordercolor="white" class="table table-condensed table-hover patient-details">
      <tbody>
          <tr>
            <th class="col-md-2" style="width: 150px">Name</th>
            <td>{{petDetail.petName}}</td>
          </tr>
        <tr>
          <th class="col-md-2" style="width: 150px">Color</th>
          <td>{{petDetail.color}}</td>
        </tr>
        <tr>
          <th style="width: 150px">Birthday</th>
          <td>
            <span *ngIf="isValidDate(petDetail)">{{getPetBirthday(petDetail) | date: 'longDate'}}</span>
          </td>
        </tr>
      </tbody>
    </table>

  </div>
  <div class="col-md-5">

    <table border="2" bordercolor="white" style="margin-bottom: 0px"
           class="table table-condensed table-hover patient-details">
      <tbody>
        <tr>
          <th style="width: 150px">Breed</th>
          <td>{{petDetail.breed}}</td>
        </tr>
        <tr>
          <th style="width: 150px">Species</th>
          <td>{{petDetail.species}}</td>
        </tr>

        <tr>
          <th style="width: 150px">Status</th>
          <td>
            <span *ngIf="petDetail.petState === 'active' else noactive"> {{petDetail.petState}}</span>
            <ng-template #noactive>
              <b style="color: red">{{petDetail.petState}}</b>
            </ng-template>
          </td>
        </tr>
      </tbody>
    </table>

  </div>

</div>
